import { IonContent, IonHeader, IonPage, IonTitle, IonToolbar, IonFab, IonFabButton, IonIcon } from '@ionic/react';
import React, { useEffect, useState } from 'react';
import ExploreContainer from '../components/ExploreContainer';
import { add, logoApple, logoAndroid, chatboxEllipsesOutline } from 'ionicons/icons';
import './Home.css';
import { RouteChildrenProps } from 'react-router';

import InstallButton from '../components/InstallPWAButton';

const Home: React.FC<RouteChildrenProps> = (props) => {
    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonTitle></IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent className="ion-padding">
                <IonHeader collapse="condense">
                    <IonToolbar>
                        <IonTitle size="large"></IonTitle>
                    </IonToolbar>
                </IonHeader>
                <ExploreContainer />
                <IonFab vertical="bottom" horizontal="start" slot="fixed">
                    <InstallButton /> 
                </IonFab>
                <IonFab vertical="bottom" horizontal="end" slot="fixed">
                    <IonFabButton onClick={() => props.history.push('/contact')} title="Contact Us">
                        <IonIcon icon={chatboxEllipsesOutline} />
                    </IonFabButton>
                </IonFab>
            </IonContent>
        </IonPage>
    );
};

export default Home;
